import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpEvent,	HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

	constructor(private readonly router: Router) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		return next.handle(request).pipe(

			retry(1),
			catchError((response: HttpErrorResponse) => {

                let errorMessage = response.error.message;

				if (response.error instanceof ErrorEvent) {

					console.error(errorMessage);

				} else {

					switch (response.status) {

                        case 0:
							console.error(errorMessage);
                            this.router.navigate(['/not-available']);
							break;

						case 401:
							console.error(errorMessage);
                            this.router.navigate(['/login']);
							break;

					}
				}

				return throwError(response);

			})

		);

	}

}
